/**
 * @module events/hooks/stopPropagation
 */

/**
 * Stops the event propagation
 * @param {Event} event
 */
export default (
  event
) => {
  event.stopPropagation()
}
